import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../api/axiosInstance';

export const fetchMe = createAsyncThunk('users/me', async () => {
  const response = await axiosInstance.get('/users/me');
  return response.data;
});

const noAdminRights = { create: false, read: false, update: false, delete: false };

// What the store knows about the user before /users/me answers, and after logout
const anonymous = {
  login: null,
  // /users/me answered with an error: the pages waiting for it stop waiting.
  meFailed: false,
  firstname: null,
  lastname: null,
  permissions: {
    future: false,
    futureAdmin: false,
    destination: false,
    reenroll: false,
    admin: { users: noAdminRights, permissions: noAdminRights },
  },
};

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    jwt: localStorage.getItem('authToken'),
    ...anonymous,
  },
  reducers: {
    setJWT: (state, action) => {
      state.jwt = action.payload;
      // Store the token in localStorage
      localStorage.setItem('authToken', action.payload);
    },
    unsetJWT: (state) => {
      state.jwt = null;
      Object.assign(state, anonymous);
      // Remove the token from localStorage
      localStorage.removeItem('authToken');
    },
    setFirstname: (state, action) => {
      state.firstname = action.payload;
    },
    setLastname: (state, action) => {
      state.lastname = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchMe.pending, (state) => {
        state.meFailed = false;
      })
      .addCase(fetchMe.fulfilled, (state, action) => {
        const capitalize = (name) => name.charAt(0).toUpperCase() + name.slice(1);
        const [firstname = '', lastname = ''] = action.payload.user.login.split('@')[0].split('.');
        state.firstname = capitalize(firstname);
        state.lastname = capitalize(lastname);
        state.permissions.future = action.payload.permissions.future;
        state.permissions.futureAdmin = action.payload.permissions.futureAdmin;
        state.permissions.destination = action.payload.permissions.destination;
        state.permissions.reenroll = action.payload.permissions.reenroll;
        state.login = action.payload.user.login;
        state.meFailed = false;
        state.permissions.admin = {
          users: { ...noAdminRights, ...action.payload.permissions.admin?.users },
          permissions: { ...noAdminRights, ...action.payload.permissions.admin?.permissions },
        };
      })
      .addCase(fetchMe.rejected, (state) => {
        state.meFailed = true;
      });
  },
})

// Action creators are generated for each case reducer function
export const {
  setJWT,
  unsetJWT,
  setFirstname,
  setLastname,
} = userSlice.actions

// The administration is the users list: profiles are only edited through their user.
export const selectCanSeeAdmin = (state) => state.user.permissions.admin.users.read;

export default userSlice.reducer